import React from 'react';

const DocumentationHome = () => {
  return <div>DocumentationHome</div>;
};

export default DocumentationHome;
